<umkt-auth-layout *ngIf="!isLoggedInFlow" scrollable>
  <div class="auth-back">
    <a routerLink="/login">
      <mat-icon>chevron_left</mat-icon>
      {{ 'pages.registerToken.backToLogin' | i18n }}
    </a>
  </div>

  <div class="auth-card-content">
    <div class="auth-card-form">
      <div class="auth-intern-form">
        <div class="auth-title">
          <h1 style="font-size: 1.5rem; font-weight: 600; line-height: 2rem; color: #1F1D1D;">
            {{ pageTitleKey | i18n }}
          </h1>
        </div>

        <div>
          <p class="auth-desc auth-register-desc">
            {{ pageDescriptionKey | i18n }}
          </p>

          <ng-container *ngTemplateOutlet="tokenFormContent"></ng-container>
        </div>
      </div>
    </div>
  </div>
</umkt-auth-layout>

<div *ngIf="isLoggedInFlow" class="register-token-logged-in">
  <div class="register-token-logged-in__container">
    <umkt-breadcrumb [items]="breadcrumbItems" [separator]="'>'"></umkt-breadcrumb>

    <header class="register-token-logged-in__header">
      <h1 class="register-token-logged-in__title">{{ pageTitleKey | i18n }}</h1>
      <p class="register-token-logged-in__subtitle">{{ pageDescriptionKey | i18n }}</p>
    </header>

    <div class="register-token-logged-in__form-card">
      <ng-container *ngTemplateOutlet="tokenFormContent"></ng-container>
    </div>
  </div>
</div>

<ng-template #tokenFormContent>
  <form [formGroup]="tokenForm" class="auth-form register-token-form" (ngSubmit)="submitTokenRegistration()">
    <div class="register-token-product-summary" *ngIf="hasProductSummary">
      <div class="register-token-product-summary__icon">
        <umkt-icon [icon]="productIcon" size="sm"></umkt-icon>
      </div>
      <div class="register-token-product-summary__body">
        <span class="register-token-product-summary__label">
          {{ 'pages.registerToken.product.label' | i18n }}
        </span>
        <h3 class="register-token-product-summary__name">
          {{ productName || planName }}
        </h3>
        <p
          class="register-token-product-summary__plan"
          *ngIf="productName && planName"
        >
          {{ planName }}
        </p>
        <span *ngIf="showFreeDomainLabel" class="pi-free-domain-label">
          {{ 'pages.productConfig.freeDomainLabel' | i18n }}
        </span>
      </div>
    </div>

    <div class="input-group">
      <umkt-custom-input
        formControlName="cnpj"
        [ariaLabel]="'pages.registerToken.cnpj.label' | i18n"
        [placeholder]="'pages.registerToken.cnpj.placeholder' | i18n"
        mask="AA.AAA.AAA/AAAA-00"
        [disabled]="true">
      </umkt-custom-input>
    </div>

    <div class="input-group">
      <umkt-custom-input
        formControlName="razaoSocial"
        [ariaLabel]="'pages.registerToken.companyName.label' | i18n"
        [placeholder]="'pages.registerToken.companyName.placeholder' | i18n"
        [maxlength]="255"
        [disabled]="true">
      </umkt-custom-input>
    </div>

    <div class="input-group">
      <umkt-custom-input
        formControlName="email"
        type="email"
        [ariaLabel]="'pages.registerToken.email.label' | i18n"
        [placeholder]="'pages.registerToken.email.placeholder' | i18n"
        [maxlength]="255">
      </umkt-custom-input>

      <div *ngIf="(emailControl?.hasError('email') || emailControl?.hasError('invalidEmailDomain'))
        && emailControl?.touched" class="field-error">
        {{ 'pages.registerToken.email.errorInvalid' | i18n }}
      </div>
    </div>

    <div class="domain-input-group" *ngIf="showDomainField">
      <div class="domain-radio-group" *ngIf="showDomainRadioButtons">
        <div class="domain-radio-item" *ngIf="isNoDomainOptionAllowed">
          <input
            type="radio"
            id="noDomain"
            formControlName="domainType"
            value="none"
            class="domain-radio"
            (change)="onDomainTypeChange()"
          />
          <label for="noDomain" class="domain-radio-label">
            {{ 'pages.registerToken.domain.none' | i18n }}
          </label>
        </div>
        <div class="domain-radio-item" *ngIf="isNewDomainOptionAllowed">
          <input
            type="radio"
            id="newDomain"
            formControlName="domainType"
            value="new"
            class="domain-radio"
            (change)="onDomainTypeChange()"
          />
          <label for="newDomain" class="domain-radio-label">
            {{ 'pages.registerToken.domain.create' | i18n }}
          </label>
        </div>
        <div class="domain-radio-item" *ngIf="isExistingDomainOptionAllowed">
          <input
            type="radio"
            id="existingDomain"
            formControlName="domainType"
            value="existing"
            class="domain-radio"
            (change)="onDomainTypeChange()"
          />
          <label for="existingDomain" class="domain-radio-label">
            {{ 'pages.registerToken.domain.existing' | i18n }}
          </label>
        </div>
      </div>

      <ng-container *ngIf="!isNoDomainSelected">
      <umkt-verify-domain
        formControlName="domain"
        [label]="'pages.registerToken.domain.label' | i18n"
        [domainSuffix]="getDomainSuffix()"
        [isValid]="domainValidationResult"
        [feedback]="getVerifyDomainFeedback()"
        (domainChange)="onDomainChange($event)"
      ></umkt-verify-domain>

      <div class="pi-ownership-verification" *ngIf="ownershipManualVerificationError">
        <p class="pi-ownership-question">
          {{ 'pages.productConfig.domain.ownershipQuestion' | i18n }}
        </p>
        <div class="pi-ownership-actions">
          <button
            type="button"
            class="pi-ownership-btn pi-ownership-btn--primary"
            (click)="onConfirmDomainOwnership()"
          >
            {{ 'pages.productConfig.domain.ownershipYes' | i18n }}
          </button>
          <button
            type="button"
            class="pi-ownership-btn pi-ownership-btn--secondary"
            (click)="onChangeDomainOwnership()"
          >
            {{ 'pages.productConfig.domain.ownershipNo' | i18n }}
          </button>
        </div>
      </div>

      <div
        class="pi-google-domain-warning"
        *ngIf="shouldShowGoogleDomainNotInUseWarning"
      >
        <div class="pi-google-domain-warning__card">
          <div class="pi-google-domain-warning__header">
            <span
              class="mdn-Icon-triangulo-exclamacao pi-google-domain-warning__icon"
              aria-hidden="true"
            ></span>
            <h4 class="pi-google-domain-warning__title">
              {{ 'pages.productConfig.domain.googleDomainNotInUseWarningTitle' | i18n }}
            </h4>
          </div>
          <div class="pi-google-domain-warning__ack">
            <input
              type="checkbox"
              class="pi-checkbox"
              id="googleDomainAck"
              [checked]="googleDomainNotInUseAcknowledged"
              (change)="onGoogleDomainNotInUseAcknowledgedChange($event)"
            />
            <label class="pi-google-domain-warning__ack-label" for="googleDomainAck">
              {{ 'pages.productConfig.domain.googleDomainNotInUseAck' | i18n }}
            </label>
          </div>
        </div>
      </div>

      <div
        class="pi-google-domain-warning"
        *ngIf="shouldShowEmailDomainOwnershipWarning"
      >
        <div class="pi-google-domain-warning__card">
          <div class="pi-google-domain-warning__header">
            <span
              class="mdn-Icon-triangulo-exclamacao pi-google-domain-warning__icon"
              aria-hidden="true"
            ></span>
            <h4 class="pi-google-domain-warning__title">
              {{ 'pages.productConfig.domain.emailDomainOwnershipWarningTitle' | i18n }}
            </h4>
          </div>
          <div class="pi-google-domain-warning__ack">
            <input
              type="checkbox"
              class="pi-checkbox"
              id="emailDomainAck"
              [checked]="confirmedDomainOwnership"
              (change)="onConfirmedDomainOwnershipChange($event)"
            />
            <label class="pi-google-domain-warning__ack-label" for="emailDomainAck">
              {{ 'pages.productConfig.domain.emailDomainOwnershipAck' | i18n }}
            </label>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="check-domain-btn"
        [disabled]="loading || hasDomainFormatError || ownershipManualVerificationError"
        (click)="checkDomainAvailability()"
      >
        {{ verifyButtonText | i18n }}
      </button>
      </ng-container>
    </div>

    <div class="terms-checkbox" *ngIf="microsoftTermsUrl">
      <input
        type="checkbox"
        id="register-token-microsoft-terms-checkbox"
        required
        [checked]="microsoftTermsAccepted"
        (change)="onMicrosoftTermsAcceptedChange($event)"
      />
      <label
        for="register-token-microsoft-terms-checkbox"
        [innerHTML]="'pages.checkout.summary.microsoftTerms' | i18n: { link: microsoftTermsUrl }"
      >
      </label>
    </div>

    <ustore-button
      type="submit"
      [text]="submitButtonKey | i18n"
      [disabled]="tokenForm.invalid || loading || (showDomainField && !isNoDomainSelected && domainValidationResult !== true) || (shouldShowGoogleDomainNotInUseWarning && !googleDomainNotInUseAcknowledged) || (shouldShowEmailDomainOwnershipWarning && !confirmedDomainOwnership) || (!!microsoftTermsUrl && !microsoftTermsAccepted)"
      [full]="true"
      [backgroundColor]="'var(--color-red-500-to-yellow)'"
      [textColor]="'var(--color-inverted)'"
      [format]="'filled'"
      [size]="'medium'"
      [rounded]="'default'"
      [icon]="{ name: 'check', type: 'material-icons', position: 'right' }">
    </ustore-button>

    <div class="auth-register" *ngIf="!isLoggedInFlow">
      {{ 'shared.auth.hasAccount' | i18n }} <a (click)="goToLogin()">{{ 'shared.buttons.login' | i18n }}</a>
    </div>
  </form>
</ng-template>

<umkt-domain-authorization-modal
  [isOpen]="showAuthorizationModal"
  [domain]="domainNeedingAuthorization"
  (closeModal)="onCloseAuthorizationModal()"
  (authorize)="onAuthorizeDomain()"
>
</umkt-domain-authorization-modal>

<umkt-domain-authorization-confirmation-modal
  [isOpen]="showAuthorizationConfirmationModal"
  [domain]="domainNeedingAuthorization"
  (confirm)="onConfirmAuthorization()"
>
</umkt-domain-authorization-confirmation-modal>
